import React, { useCallback, useEffect, useState } from 'react'
import Box from '@mui/material/Box'
import { MediaType } from '../../lib/types'
import Skeleton from '@mui/material/Skeleton'

interface iCardImage {
  thumbnail: string
  preview?: string
  type?: MediaType | 'COLLECTION'
}

const CardImage: React.FC<iCardImage> = ({ type, thumbnail, preview }) => {
  const [isLoading, setLoading] = useState<boolean>(true)
  const [error, setError] = useState<boolean>(false)
  const [image, setImage] = useState<string>(
    type === 'COLLECTION' ? '/images/CoverCardPlaceholder2.png' : '/images/CoverCardPlaceholder.png'
  )
  const [hover, setHover] = useState<boolean>(false)

  useEffect(() => {
    if (!error && preview) {
      setImage(hover ? preview : thumbnail)
    } else {
      setImage(thumbnail || '')
    }
  }, [hover, error])

  const handleError = useCallback(() => {
    if (type === 'COLLECTION') {
      setImage('/images/CoverCardPlaceholder2.png')
      return
    }
    setImage('/images/CoverCardPlaceholder.png')
  }, [type])

  const handleMouseEnter = useCallback(() => {
    !error && setHover(true)
  }, [error])

  const handleMouseLeave = useCallback(() => {
    !error && setHover(false)
  }, [error])

  const handleLoadStart = useCallback(() => {
    setLoading(true)
  }, [])

  const handleLoad = useCallback(() => {
    setLoading(false)
  }, [])

  const handleImgError = useCallback(() => {
    handleError()
    setLoading(false)
    setError(true)
  }, [handleError])

  return (
    <Box
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      sx={{
        position: 'relative',
        width: '100%',
        height: '100%'
      }}
    >
      <Box
        component="img"
        sx={{
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          objectPosition: 'center',
          borderTopLeftRadius: 8,
          borderTopRightRadius: 8,
          display: !isLoading ? 'block' : 'none'
        }}
        src={image}
        alt="preview"
        onLoadStart={handleLoadStart}
        onLoad={handleLoad}
        onError={handleImgError}
      />
      {isLoading && (
        <Box
          sx={{
            width: '100%',
            height: '100%',
            position: 'absolute',
            top: '0',
            left: '0',
            zIndex: '1'
          }}
        >
          <Skeleton
            variant="rectangular"
            animation="wave"
            sx={{
              borderTopLeftRadius: 8,
              borderTopRightRadius: 8,
              width: '100%',
              height: '100%'
            }}
          />
        </Box>
      )}
    </Box>
  )
}

export default React.memo(CardImage)
